var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReagents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 0H0V1.77778H1.8V20.4444C1.8 22.4081 3.41178 24 5.4 24C7.38823 24 9 22.4081 9 20.4444V1.77778H10.8V0ZM8.1 8.88889H2.7V20.4444C2.7 21.9172 3.90883 23.1111 5.4 23.1111C6.89117 23.1111 8.1 21.9172 8.1 20.4444V8.88889Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9997 0H13.1997V1.77778H14.9997V20.4444C14.9997 22.4081 16.6115 24 18.5997 24C20.5879 24 22.1997 22.4081 22.1997 20.4444V1.77778H23.9997V0ZM21.2997 13.2H15.8997V20.4444C15.8997 21.9172 17.1085 23.1111 18.5997 23.1111C20.0909 23.1111 21.2997 21.9172 21.2997 20.4444V13.2Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReagents);
export default __webpack_public_path__ + "static/media/Reagents.9ae23123d815362ba6ba4d6ff19c49fb.svg";
export { ForwardRef as ReactComponent };